document.addEventListener("DOMContentLoaded", () => {
  
  async function loadCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!cartDrawer) return false;
    
    try {
      const response = await fetch("/cart?section_id=cart-drawer");
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');
      
      if (newCartDrawer) {
        Array.from(newCartDrawer.attributes).forEach(attr => {
          if (attr.name !== 'class') {
            cartDrawer.setAttribute(attr.name, attr.value);
          }
        });
        
        cartDrawer.innerHTML = newCartDrawer.innerHTML;
        
        const cart = await getCart();
        if (cart && cart.item_count > 0) {
          cartDrawer.classList.remove('is-empty');
        }
        
        if (!cartDrawer.classList.contains('drawer')) {
          cartDrawer.classList.add('drawer');
        }
        
        return true;
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  
  function updateCartCount(count) {
    const section = document.querySelector('#shopify-section-cart-icon-bubble');
    
    if (section) {
      let countBubble = section.querySelector('.cart-count-bubble');
      
      if (!countBubble) {
        countBubble = document.createElement('div');
        countBubble.className = 'cart-count-bubble';
        countBubble.innerHTML = `
          <span aria-hidden="true">${count}</span>
          <span class="visually-hidden">${count === 1 ? '1 item' : `${count} items`}</span>
        `;
        section.appendChild(countBubble);
      } else {
        const ariaSpan = countBubble.querySelector('span[aria-hidden="true"]');
        const visuallyHiddenSpan = countBubble.querySelector('.visually-hidden');
        
        if (ariaSpan) ariaSpan.textContent = count;
        if (visuallyHiddenSpan) {
          visuallyHiddenSpan.textContent = count === 1 ? '1 item' : `${count} items`;
        }
      }
    }
  }
  
  async function getCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      return res.ok ? await res.json() : null;
    } catch (e) {
      return null;
    }
  }
  
  async function waitForCartChange(prevCount, timeout = 8000) {
    const start = Date.now();
    while (Date.now() - start < timeout) {
      const cart = await getCart();
      if (cart && cart.item_count !== prevCount) {
        return cart;
      }
      await new Promise(r => setTimeout(r, 300));
    }
    return null;
  }
  
  function bindButtons() {
    const buttons = document.querySelectorAll('button.swym-add-to-cart-btn');
    
    buttons.forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = "true";
      
      button.addEventListener('click', () => {
        setTimeout(async () => {
          const cart = await getCart();
          if (cart) {
            updateCartCount(cart.item_count);
            await loadCartDrawer();
          }
        }, 700);
      });
    });
  }
  
  let cartDrawerCheckInFlight = false;
  let cartDrawerCheckTimer = null;

  function scheduleCheckCartDrawerState() {
    if (cartDrawerCheckTimer) return;

    cartDrawerCheckTimer = setTimeout(async () => {
      cartDrawerCheckTimer = null;

      if (cartDrawerCheckInFlight) return;
      cartDrawerCheckInFlight = true;

      try {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        const cart = await getCart();
        if (cart && cart.item_count > 0) {
          cartDrawer.classList.remove('is-empty');
        }
      } finally {
        cartDrawerCheckInFlight = false;
      }
    }, 400);
  }

  function observeCartDrawerOpen() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    let wasOpen = cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate');

    const observer = new MutationObserver(() => {
      const isOpen = cartDrawer.classList.contains('active') || cartDrawer.classList.contains('animate');

      if (!wasOpen && isOpen) {
        scheduleCheckCartDrawerState();
      }

      wasOpen = isOpen;
    });

    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  setTimeout(observeCartDrawerOpen, 1000);
  
  setTimeout(bindButtons, 1000);
  
  function debounce(fn, ms) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  new MutationObserver(debounce(bindButtons, 300)).observe(document.body, {
    childList: true,
    subtree: true
  });
});
